import React from 'react';
import { useTheme } from 'styled-components';
import { getPeriodsPerformance, getFundsManagementCompaniesPath } from '@finect/front-resources/Products';
import { KPIs, KPI } from '../../Products';
import { Section } from '../../Section';
import { AssetsLabel, PercentLabel } from '../../Products/Labels';
export var CategoryKPIs = function CategoryKPIs(_ref) {
  var productType = _ref.productType,
    category = _ref.category;
  var theme = useTheme();
  var managementCompanies = category.managementCompanies ? category.managementCompanies : [];
  var M36A = getPeriodsPerformance(category.stats.performance, 'M36', 'annualized');
  var M36 = getPeriodsPerformance(category.stats.performance, 'M36', 'accumulated');
  var M12 = getPeriodsPerformance(category.stats.performance, 'M12', 'accumulated');
  return React.createElement(Section, {
    bottomMargin: true,
    title: "Datos clave"
  }, React.createElement(KPIs, null, React.createElement(KPI, {
    title: managementCompanies.length,
    subtitle: "Gestoras",
    href: "".concat(getFundsManagementCompaniesPath(theme, productType))
  }), React.createElement(KPI, {
    title: React.createElement(AssetsLabel, {
      value: category.stats.assets,
      scale: "million",
      decimals: 0
    }),
    subtitle: "Activos"
  }), React.createElement(KPI, {
    title: React.createElement(PercentLabel, {
      value: M36 ? M36.value : null
    }),
    subtitle: "Rentabilidad a 3 a\xF1os absoluta"
  }), React.createElement(KPI, {
    title: React.createElement(PercentLabel, {
      value: M36A ? M36A.value : null
    }),
    subtitle: "Rentabilidad a 3 a\xF1os anualizada"
  }), React.createElement(KPI, {
    title: React.createElement(PercentLabel, {
      value: M12 ? M12.value : null
    }),
    subtitle: "Rentabilidad a 1 a\xF1o"
  })));
};